import { cva } from '@/styled-system/css';

export const iconButtonIconRecipe = cva({
  variants: {
    loading: {
      true: {
        color: 'transparent.invisible',
      },
      false: {},
    },
  },
});
